import './StaffLogin.css';
import React, { useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://vakra.co.in';

const normalizeMobile = (value) =>
  String(value || '')
    .replace(/\D/g, '')
    .slice(0, 10);

const normalizePin = (value) =>
  String(value || '')
    .replace(/\D/g, '')
    .slice(0, 6);

const StaffLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const vendorId = searchParams.get('vendor') || '';
  const vendorType = searchParams.get('vendorType') || 'fastfood';

  const [mobile, setMobile] = useState('');
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const linkInfo = useMemo(
    () => ({
      vendorId,
      vendorType,
    }),
    [vendorId, vendorType]
  );

  const handleLogin = async (event) => {
    event.preventDefault();

    const cleanMobile = normalizeMobile(mobile);
    const cleanPin = normalizePin(pin);

    if (!linkInfo.vendorId) {
      setMessage('Vendor id missing hai. Owner se correct staff login link lein.');
      return;
    }

    if (cleanMobile.length !== 10) {
      setMessage('Valid 10 digit mobile number enter karein.');
      return;
    }

    if (cleanPin.length < 4) {
      setMessage('Valid 4-6 digit PIN enter karein.');
      return;
    }

    try {
      setLoading(true);
      setMessage('');

      const res = await axios.post(`${BASE_URL}/api/staff-management/login`, {
        vendorId: linkInfo.vendorId,
        vendorType: linkInfo.vendorType,
        mobile: cleanMobile,
        pin: cleanPin,
      });

      const token = res?.data?.token || '';
      const staff = res?.data?.staff || null;

      if (!token || !staff) {
        setMessage('Staff login response invalid hai.');
        return;
      }

      /*
        Staff login ke baad owner token remove karna zaruri hai.
        Warna same browser me owner ka localStorage token use hoga aur staff ko full owner access mil jayega.
      */
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('vendor');

      sessionStorage.setItem('staff_token', token);
      sessionStorage.setItem('staff_user', JSON.stringify(staff));
      sessionStorage.setItem('staff_permissions', JSON.stringify(staff.permissions || {}));
      sessionStorage.setItem('staff_vendor_id', String(linkInfo.vendorId || ''));
      sessionStorage.setItem('staff_vendor_type', String(linkInfo.vendorType || 'fastfood'));
      sessionStorage.setItem('login_type', 'staff');

      navigate('/ordersReceived', { replace: true });
    } catch (err) {
      setMessage(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          'Staff login nahi hua.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="staff-login-page">
      <section className="staff-login-card">
        <div className="staff-login-logo">👥</div>

        <h1>Staff Login</h1>
        <p className="staff-login-subtitle">
          Owner ne jo mobile number aur PIN diya hai usse login karein.
        </p>

        <div className="staff-login-info">
          <span>
            <b>Vendor:</b> {linkInfo.vendorId || 'Missing'}
          </span>
          <span>
            <b>Type:</b> {linkInfo.vendorType || 'fastfood'}
          </span>
        </div>

        <form onSubmit={handleLogin} className="staff-login-form">
          <label>
            Mobile Number
            <input
              value={mobile}
              onChange={(event) => setMobile(normalizeMobile(event.target.value))}
              placeholder="10 digit mobile"
              inputMode="numeric"
              autoComplete="tel"
            />
          </label>

          <label>
            PIN
            <input
              value={pin}
              onChange={(event) => setPin(normalizePin(event.target.value))}
              placeholder="4-6 digit PIN"
              inputMode="numeric"
              type="password"
              autoComplete="current-password"
            />
          </label>

          {message ? <div className="staff-login-error">{message}</div> : null}

          <button type="submit" disabled={loading}>
            {loading ? 'Login...' : 'Login'}
          </button>
        </form>

        <p className="staff-login-note">
          PIN bhool gaye ho to owner se Reset PIN karwao.
        </p>
      </section>
    </main>
  );
};

export default StaffLogin;
